<template>
  <div ref="chartEl" id="barChart" style="min-height: 400px;" class="echart"></div>
</template>

<script setup>
import {computed, onMounted, onBeforeUnmount, ref, watch} from 'vue';
import {getCurrencyFormatted} from "@/api/helpers";

const props = defineProps({
  elements: {type: Array, default: () => []},
  currency: String
});

const chartEl = ref(null);
let chart = null;

const chartValues = computed(() =>
    (props.elements || [])
    .map(el => ({
      amount: Number(el.amount ?? 0),
      name: el.name ?? '',
    }))
    .sort((a, b) => b.amount - a.amount)
);

function render() {
  if (!chart || !chartEl.value) return;

  chart.setOption({
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `
          ${params.marker}
          <strong>${params.name}</strong><br/>
          ${getCurrencyFormatted(params.value, props.currency)}
        `;
      }
    },
    xAxis: {
      type: 'category',
      data: chartValues.value.map(el => el.name)
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      label: {show: false, position: 'center', formatter: '{b}: {d}%',},
      data: chartValues.value.map(el => el.amount),
      type: 'bar'
    }]
  }, true);
}

onMounted(() => {
  chart = echarts.init(chartEl.value);
  render();
});
watch(chartValues, () => {
  render();
});

onBeforeUnmount(() => {
  if (chart) {
    chart.dispose();
    chart = null;
  }
});
</script>